module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"message":"Die folgenden Liegenschaften wurden ausgeschlossen, da sie bei der Berechnung Fehler aufwiesen:"}}')
  delete Component.options._Ctor
}
